var map = {
	"./img_Android_qr.png": 82062,
	"./img_STEP1.png": 82077,
	"./img_STEP2.png": 57107,
	"./img_STEP2_before.png": 11253,
	"./img_STEP3.png": 37153,
	"./img_STEP4.png": 86801,
	"./img_STEP5.png": 25479,
	"./img_STEP6.png": 5342,
	"./img_STEP7.png": 4196,
	"./img_app_banner_back.png": 77111,
	"./img_iOS_qr.png": 41260,
	"./img_information_background.png": 90308,
	"./img_information_checked.png": 48613,
	"./img_information_coin.png": 16611,
	"./img_information_sheild.png": 42201,
	"./img_kyc_background.png": 74571,
	"./img_kyc_checked.png": 14783,
	"./img_kyc_focus.png": 25142,
	"./img_kyc_id_card.png": 60486,
	"./img_kyc_shadow.png": 52921,
	"./img_kyc_sheild.png": 26907
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55029;